import React from "react";
import { useField } from "formik";

import styles from "./Input.module.scss";

const Input = React.forwardRef(({ label, className, ...props }, ref) => {
  const [field, meta] = useField(props);

  return (
    <>
      <div className={styles.container}>
        <input
          className={`${styles.container} ${
            meta.touched && meta.error ? `${styles.error}` : ""
          }`}
          ref={ref}
          {...field}
          {...props}
          onBlur={(event) => {
            field.onBlur(event);
            props.onBlur && props.onBlur();
          }}
          onFocus={(event) => {
            props.onFocus && props.onFocus();
          }}
          onChange={(event) => {
            field.onChange(event);
            props.onChange && props.onChange(event);
          }}
        />

        <label className={styles.label}>{label}</label>
      </div>

      {/* {meta.touched && meta.error ? (
                <div className={styles.errorText}>{meta.error}</div>
            ) : null} */}
    </>
  );
});

export default React.memo(Input);
